// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kwnx","title":"Header_title__2qpUC","side":"Header_side__weCgx"};